/*
 HotelTest

 Tresc regulaminu dla hotel-TEST
  
 historia: 
  PM 2021-12-08 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';

class HotelTest extends React.Component<WithStyles<typeof styles>, any> {

    render() {
        const { classes } = this.props;
        if (document.title !== 'Warunki wynajmu') {
            document.title = 'Warunki wynajmu';
        }

        return (
            <React.Fragment>
                <Typography variant='h6' align="center"><b>WARUNKI WYNAJMU MARAND LOFT</b></Typography><br />
                <ol type="1">
                    <li><Typography variant='body2' gutterBottom>Strona internetowa <a href="https://marandloft.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://marandloft.pl/
                        </Button>
                    </a> przeznaczona jest do rezerwacji noclegów w apartamentach.</Typography>
                    <Typography variant='body2' gutterBottom>Właścicielem serwisu oraz prezentowanych na stronie apartamentowców jest firma MARLAND P. MARCZYDŁO DEWELOPER SP. K 36-062 Zaczernie 917 NIP: 5170378444  tel.<a href={`tel:${'+48531898551'}`} className={`${classes.email}`}>{'+48 531 898 551'}</a> oraz tel.<a href={`tel:${'+48530660081'}`} className={`${classes.email}`}>{'+48 530 660 081'}</a> adres poczty elektronicznej: <a href={`mailto:${'rezerwacje@marandloft.pl'}`} target='_blank' className={`${classes.email}`}>{'rezerwacje@marandloft.pl'}</a> </Typography>
                    <Typography variant='body2' gutterBottom>Numer rachunku bankowego 88 1140 2004 0000 3402 8595 0703</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji apartamentów można dokonywać on-line za pośrednictwem serwisu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Warunkiem rezerwacji jest płatność on-line 100% ceny za wynajem w momencie rezerwacji.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Możliwa jest tylko płatność online.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności są <b>Przelewy24.</b></Typography></li>
                    <li><Typography variant='body2' gutterBottom>Rezerwacji można również dokonywać przez portal rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Operatorem płatności w przypadku rezerwacji przez serwis rezerwacyjny <a href="https://www.booking.com/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            booking.com
                        </Button>
                    </a> jest ten serwis.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W obiekcie akceptujemy tylko płatności online.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Zakwaterowanie w apartamentach odbywa się bezobsługowo na podstawie szczegółowych instrukcji oraz kodów dostępu wysyłanych w wiadomości booking ,e-mail lub sms w dniu przyjazdu. Gość otrzymuje kod dostępu do drzwi głównych wejściowych oraz do skrytki, znajdującej się w holu recepcyjnym lub kod dostępu do apartamentu sms-em na nr podany w rezerwacji.  Po wpisaniu kodu Gość otworzy skrytkę, w której będą klucze do apartamentu  lub dostanie się do niego za pomocą otrzymanego kodu.   Zakwaterowanie jest możliwe od godziny 15:00, wymeldowanie do godz. 10:00 ostatniego dnia pobytu.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>W przypadku anulowania rezerwacji na jeden lub więcej dni przed przyjazdem, Gość otrzyma pełny zwrot wpłaconych środków pomniejszonych o prowizję operatora płatności. Zwrot będzie wykonany w ciągu maksymalnie 7 dni roboczych na wskazany rachunek bankowy. W przypadku anulowania na mniej niż 1 dni przed przyjazdem, rezerwacja jest bezzwrotna. Ewentualny zwrot w takim przypadku jest rozpatrywany indywidualnie.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Wszelkie reklamacje powinny być zgłaszane pisemnie poprzez formularz kontaktowy na stronie <a href="https://marandloft.pl/" target="_blank" rel="noreferrer" className={classes.link}>
                        <Button
                            variant="text"
                            size="large"
                            className={`${classes.linkButton} ${classes.body2Button}`}
                        >
                            https://marandloft.pl/
                        </Button>
                    </a> lub mailowo na adres <a href={`mailto:${'rezerwacje@marandloft.pl'}`} target='_blank' className={`${classes.email}`}>{'rezerwacje@marandloft.pl'}</a>.</Typography></li>
                    <li><Typography variant='body2' gutterBottom>Czas odpowiedzi na reklamację wynosi do 7 dni roboczych.</Typography></li>
                </ol>
                
            
                {/* <br /><Typography align="right" gutterBottom>Dyrektor PPUH Hayduk</Typography>
                <Typography align="right" gutterBottom><b>Koralewska Monika</b></Typography> */}
            </React.Fragment>
        );
    }
}

const styles = (theme: Theme) => ({
    noMarginTop: {
        marginTop: 0,
    },
    noMarginBottom: {
        marginBottom: 0,
    },
    listItem: {
        display: 'list-item',
        marginLeft: theme.spacing(5),
    },
    listNone: {
        listStyleType: 'none'
    },
    breakSpaces: {
        whiteSpace: 'break-spaces' as 'break-spaces'
    },
    linkButton: {
        color: '#3a87ad',
        "&:hover": {
            textDecoration: "underline"
        }
    },
    h6Button: {
        padding: 0,
        fontSize: theme.typography.h6.fontSize,
        lineHeight: theme.typography.h6.lineHeight,
        letterSpacing: theme.typography.h6.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    body2Button: {
        padding: 0,
        fontSize: theme.typography.body2.fontSize,
        lineHeight: '16px',
        letterSpacing: theme.typography.body2.letterSpacing,
        textTransform: 'none' as 'none',
        minWidth: 0,
        "&:hover": {
            background: 'none'
        }
    },
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere'
    },
    alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
    },
    email: {
        //color: "inherit",
        color: '#3a87ad',
        textDecoration: "none",
        "&:hover": {
            textDecoration: "underline"
        }
    },
});

export default withStyles(styles)(HotelTest);
